import { useEffect, useState } from 'react';
import { isIOSSafariNotInstalled } from '../../utils/pwaDetect';
import './style-ios.css';

interface InstallPWAiOSProps {
  icon: string;
  name: string;
}

const IOS_INSTALL_MODAL_KEY = 'iosInstallModalDismissed';
const IOS_INSTALL_VIDEO_URL =
  'https://oqapi-production.s3.us-east-1.amazonaws.com/VideoTutorials/1772804577653-90f567b8-a412-4cb8-b703-d5f3ad0010a8';

export function InstallPWAiOS({ icon, name }: InstallPWAiOSProps) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const alreadyDismissed = localStorage.getItem(IOS_INSTALL_MODAL_KEY);
    if (!alreadyDismissed && isIOSSafariNotInstalled()) {
      setIsOpen(true);
    }
  }, []);

  function handleClose() {
    localStorage.setItem(IOS_INSTALL_MODAL_KEY, 'true');
    setIsOpen(false);
  }

  if (!isOpen) return null;

  return (
    <div className="ios-install-overlay">
      <div className="ios-install-card">
        <div className="ios-install-card-header">
          <img src={icon} alt={`Icone do aplicativo ${name}`} />
          <div>
            <h2>{name}</h2>
            <span>Instale nosso app no seu iPhone</span>
          </div>
        </div>

        <div className="ios-install-video">
          <video
            src={IOS_INSTALL_VIDEO_URL}
            controls
            preload="metadata"
            playsInline
            muted
          />
        </div>

        <div className="ios-install-steps">
          <div className="ios-install-step">
            <span className="ios-install-step-number">1</span>
            <p>
              Toque no botao <strong>Compartilhar</strong>{' '}
              <i className="material-icons">ios_share</i> na barra do Safari
            </p>
          </div>

          <div className="ios-install-step">
            <span className="ios-install-step-number">2</span>
            <p>
              Role as opcoes e toque em{' '}
              <strong>"Adicionar a Tela de Inicio"</strong>{' '}
              <i className="material-icons">add_box</i>
            </p>
          </div>

          <div className="ios-install-step">
            <span className="ios-install-step-number">3</span>
            <p>
              Confirme tocando em <strong>"Adicionar"</strong>
            </p>
          </div>
        </div>

        <button className="ios-install-btn" onClick={handleClose}>
          Entendi
        </button>
      </div>
    </div>
  );
}
